import { render, staticRenderFns } from "./BookAppealDateAppRightToAppealPg.vue?vue&type=template&id=7e55cc88&scoped=true"
import script from "./BookAppealDateAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./BookAppealDateAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e55cc88",
  null
  
)

export default component.exports